module.exports = __webpack_public_path__ + "static/media/AssistantLogo.7a5b8b46.png";